module.exports = __webpack_public_path__ + "ui-static/img/videos-no-items_dark.528fcf38.svg";